import React from 'react'
import {Settings} from 'react-feather'

export const settingsNavigation = []
